import { unlockAudio } from "@/lib/ringtone";

let ctx = null;
const getCtx = () => {
  if (!ctx) { const AC = window.AudioContext || window.webkitAudioContext; if (!AC) return null; ctx = new AC(); }
  if (ctx.state === "suspended") ctx.resume().catch(() => null);
  return ctx;
};

const tone = (c, freq, start, dur, vol = 0.18, type = "sine") => {
  const o = c.createOscillator(); const g = c.createGain();
  o.type = type; o.frequency.value = freq;
  g.gain.setValueAtTime(0, start); g.gain.linearRampToValueAtTime(vol, start + 0.015); g.gain.exponentialRampToValueAtTime(0.001, start + dur);
  o.connect(g).connect(c.destination); o.start(start); o.stop(start + dur);
};

const beepFallback = (() => {
  let el = null;
  return () => {
    try {
      if (!el) {
        const sr = 8000, len = sr * 0.18, buf = new ArrayBuffer(44 + len), v = new DataView(buf);
        const w = (o, s) => { for (let i = 0; i < s.length; i++) v.setUint8(o + i, s.charCodeAt(i)); };
        w(0, "RIFF"); v.setUint32(4, 36 + len, true); w(8, "WAVEfmt "); v.setUint32(16, 16, true); v.setUint16(20, 1, true); v.setUint16(22, 1, true); v.setUint32(24, sr, true); v.setUint32(28, sr, true); v.setUint16(32, 1, true); v.setUint16(34, 8, true); w(36, "data"); v.setUint32(40, len, true);
        for (let i = 0; i < len; i++) v.setUint8(44 + i, 128 + Math.round(Math.sin(i / sr * 880 * 2 * Math.PI) * 60 * (1 - i / len)));
        el = new Audio(URL.createObjectURL(new Blob([buf], { type: "audio/wav" })));
      }
      el.currentTime = 0; el.volume = 1; el.play().catch(() => null);
    } catch (e) { /* ignore */ }
  };
})();

const play = (seq) => {
  unlockAudio();
  const c = getCtx();
  if (!c) { beepFallback(); return; }
  const run = () => { const t = c.currentTime; seq.forEach(([f, d, l, v, ty]) => tone(c, f, t + d, l, v, ty)); };
  if (c.state === "running") { run(); return; }
  c.resume().then(() => { if (c.state === "running") run(); else beepFallback(); }).catch(beepFallback);
};

export const SOUNDS = {
  chatSend: () => play([[880, 0, 0.09, 0.12]]),
  chatReceiveCustomer: () => play([[660, 0, 0.12, 0.18], [990, 0.12, 0.16, 0.18]]),
  chatReceiveStaff: () => play([[523, 0, 0.1, 0.2, "triangle"], [659, 0.1, 0.1, 0.2, "triangle"], [784, 0.2, 0.18, 0.2, "triangle"]]),
  giftUnlock: () => play([[523, 0, 0.12, 0.2], [659, 0.1, 0.12, 0.2], [784, 0.2, 0.12, 0.2], [1047, 0.3, 0.35, 0.25], [1319, 0.45, 0.4, 0.15]]),
  warn: () => play([[440, 0, 0.2, 0.2, "square"], [440, 0.3, 0.2, 0.2, "square"]]),
  paymentAlert: () => play([[1319, 0, 0.12, 0.3, "square"], [1568, 0.12, 0.12, 0.3, "square"], [1319, 0.28, 0.12, 0.3, "square"], [1568, 0.4, 0.12, 0.3, "square"], [2093, 0.52, 0.35, 0.3, "square"]]),
};
